export default "__VITE_ASSET__U1eE5oR0__"